import { OnApplicationReady } from './types';
import useMessageHandler from './useEddyMessaging/useMessageHandler';

export type ApplicationReadyMessageData = {
  type: 'applicationReady';
};

export type UseApplicationReadyMessagingProps = {
  iframe?: HTMLIFrameElement | null;
  onApplicationReady?: OnApplicationReady;
};

export default function useApplicationReadyMessaging({
  iframe,
  onApplicationReady,
}: UseApplicationReadyMessagingProps) {
  useMessageHandler<ApplicationReadyMessageData>(
    e => {
      if (e.data.type === 'applicationReady') {
        onApplicationReady?.();
      }
    },
    { iframe },
  );
}
